import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token
}

const getAuthConfig = () => {
	const token = getUserToken()
	return {
		headers: {
			authorization: `Bearer ${token}`
		}
	}
}

const currentProjectId = () => sessionStorage.getItem('current_project')

const includeTypes = [
	'gopersonal',
	'gopersonal_broadcasts',
	'custom'
]

const _getCalvinWorkspaces = ({ integrationId, type } = {}) => {
	const params = new URLSearchParams()
	const project = currentProjectId()
	if (project) params.set('project', project)
	if (integrationId) params.set('integrationId', integrationId)
	if (type) params.set('type', type)
	if (includeTypes) params.set('includeTypes', includeTypes.join(','))

	const queryString = params.toString()
	const url = `${window.config.VUE_APP_BACKEND}/api/calvins/workspaces${queryString ? `?${queryString}` : ''}`
	return Request.get(url, getAuthConfig())
}

const _getCalvinWorkspace = ({ integrationId, workspaceId } = {}) => {
	const params = new URLSearchParams()
	const project = currentProjectId()
	if (project) params.set('project', project)
	if (integrationId) params.set('integrationId', integrationId)
	const queryString = params.toString()

	return Request.get(
		`${window.config.VUE_APP_BACKEND}/api/calvins/workspaces/${workspaceId}${queryString ? `?${queryString}` : ''}`,
		getAuthConfig()
	)
}

const _getCalvinChats = ({ integrationId, workspace, status, limit, offset, orderBy } = {}) => {
	const params = new URLSearchParams()
	const project = currentProjectId()
	if (project) params.set('project', project)
	if (integrationId) params.set('integrationId', integrationId)
	if (workspace) params.set('workspace', workspace)
	if (status) params.set('status', status)
	//if (only_external_chats !== undefined) params.set('only_external_chats', only_external_chats)
	if (limit !== undefined) params.set('limit', limit)
	if (offset !== undefined) params.set('offset', offset)
	if (orderBy) params.set('orderBy', orderBy)
	if (includeTypes) params.set('includeTypes', includeTypes.join(','))

	const queryString = params.toString()
	const url = `${window.config.VUE_APP_BACKEND}/api/calvins/chats${queryString ? `?${queryString}` : ''}`
	return Request.get(url, getAuthConfig())
}

const _getCalvinChat = ({ integrationId, chatId, workspace, only_external_chats, goal } = {}) => {
	const params = new URLSearchParams()
	const project = currentProjectId()
	if (project) params.set('project', project)
	if (integrationId) params.set('integrationId', integrationId)
	if (workspace) params.set('workspace', workspace)
	if (only_external_chats !== undefined) params.set('only_external_chats', only_external_chats)
	if (goal) params.set('goal', goal)
const queryString = params.toString()

	return Request.get(
		`${window.config.VUE_APP_BACKEND}/api/calvins/chats/${chatId}${queryString ? `?${queryString}` : ''}`,
		getAuthConfig()
	)
}

const _postCalvinChat = ({ integrationId, message, workspace, chat_id, chat_name } = {}) => {
	const params = new URLSearchParams()
	const project = currentProjectId()
	if (project) params.set('project', project)
	if (integrationId) params.set('integrationId', integrationId)
	const queryString = params.toString()

	return Request.post(
		`${window.config.VUE_APP_BACKEND}/api/calvins/chats${queryString ? `?${queryString}` : ''}`,
		{ message, workspace, chat_id, chat_name },
		getAuthConfig()
	)
}

// Aprovisiona Calvin para el proyecto actual: el backend crea el store en
// calvincode (workspace + api key + soporte@gopersonal.com) y la integración.
// Idempotente: si la integración ya existe la devuelve. Tarda unos segundos.
const _provisionCalvin = () => {
	const params = new URLSearchParams();
	const project = currentProjectId();
	if (project) params.set('project', project);
	const queryString = params.toString();

	return Request.post(
		`${window.config.VUE_APP_BACKEND}/api/calvins/provision${queryString ? `?${queryString}` : ''}`,
		{},
		getAuthConfig()
	);
};

const _startCalvinWorkspace = ({ integrationId, workspace, goal } = {}) => {
	const params = new URLSearchParams()
	const project = currentProjectId()
	if (project) params.set('project', project)
	if (integrationId) params.set('integrationId', integrationId)
	if (workspace) params.set('id', workspace)
	// GoPersonal Auto: the goal's own Calvin key = the runtime user = the running container
	if (goal) params.set('goal', goal)
	const queryString = params.toString()

	return Request.post(
		`${window.config.VUE_APP_BACKEND}/api/calvins/workspaces/start${queryString ? `?${queryString}` : ''}`,
		{ workspace },
		getAuthConfig()
	)
}

export default {
	getCalvinWorkspaces: _getCalvinWorkspaces,
	getCalvinWorkspace: _getCalvinWorkspace,
	getCalvinChats: _getCalvinChats,
	getCalvinChat: _getCalvinChat,
	postCalvinChat: _postCalvinChat,
	startCalvinWorkspace: _startCalvinWorkspace,
	provisionCalvin: _provisionCalvin
}
